<template>
  <div class="gs-app gs-portal">
    <div v-if="hasContent('header')" class="gs-portal__header">
      <slot name="header" />
    </div>

    <div v-if="hasContent('hero')" class="gs-portal__hero">
      <slot name="hero" />
    </div>

    <div class="gs-portal__body" :class="{ 'gs-portal__body--full': !hasContent('rail') }">
      <aside v-if="hasContent('rail')" class="gs-portal__rail">
        <slot name="rail" />
      </aside>
      <div class="gs-portal__main">
        <slot />
      </div>
    </div>

    <div v-if="hasContent('footer')" class="gs-portal__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AffiliatePortalShell',
  methods: {
    // A slot that only holds a `v-if`ed element still yields a comment vnode,
    // so an empty region would otherwise render its padding and border.
    hasContent(name) {
      const nodes = this.$slots[name];

      if (!nodes || !nodes.length) {
        return false;
      }

      return nodes.some(node => node.tag || (node.text && node.text.trim()));
    },
  },
};
</script>

<style scoped>
/* No fixed viewport heights anywhere: this shell is embedded in an iframe that
   is sized by iframe-resizer from the document's natural height. */
.gs-portal {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  padding: 20px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gs-portal__header,
.gs-portal__hero,
.gs-portal__footer {
  min-width: 0;
}

.gs-portal__body {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  min-width: 0;
}

.gs-portal__body--full {
  grid-template-columns: minmax(0, 1fr);
}

.gs-portal__rail,
.gs-portal__main {
  min-width: 0;
}

@media (max-width: 899px) {
  .gs-portal__body {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
}

@media (max-width: 640px) {
  .gs-portal {
    gap: 14px;
    padding: 12px;
  }
}
</style>
